export default "__VITE_ASSET__d956e88e__"